import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class UserRoleApi {

    static fetchAll() {
        return HTTP.get(config.userApi.role)
            .then(response => response.data);
    }

    static add(role) {
        return HTTP.post(config.userApi.role, role)
            .then(response => response.data);
    }

    static update(role) {
        return HTTP.put(config.userApi.role, role)
            .then(response => response.data);
    }

    static delete(id) {
        return HTTP.delete(`${config.userApi.role}/${id}`)
            .then(response => response.data);
    }
}